import { AnyAction } from 'redux';
import { handleActions } from 'redux-actions';

// reducers
// Vestigial: the Clinics directory page reads via `.$promise` + local state,
// so this reducer holds no slice data (mirrors LaboratoryReducer's shape).
const defaultState = {};

type State = typeof defaultState;

const reducer = handleActions<State, AnyAction>({
}, defaultState);

export default reducer;
